const topics = [
  {
    title: "Motion", standardNumber: "4-PS3-1", slug: "motion",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmotion2025video.mp4?alt=media&token=90933e74-b520-41d9-8d19-f01f4a9a2204 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230 ",
    lyrics: ["(Chorus)",
  "If an object changes its position,",
  "Then a motion has occurred.",
  "If it continuously changes its position,",
  "Then it's in motion, then it's in motion.",
  
  "(Verse)",
  "Use a car as an example, and the car is parked at the curb.",
  "Now, you move the car up 10 feet, then a motion has occurred.",
  "Now, if you take the same parked car and put it on the highway,",
  "Then start coasting.",
  "Its position is constantly changing.",
  "Then, it's in motion, then it's in motion.",
  
  "(Chorus)",
  "If an object changes its position,",
  "Then a motion has occurred.",
  "If it continuously changes its position,",
  "Then it's in motion, then it's in motion.",
  "If an object changes its position,",
  "Then a motion has occurred.",
  "If it continuously changes its position,",
  "Then it's in motion, then it's in motion.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Force", standardNumber: "4-PS3-1", slug: "force",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fforce.mp4?alt=media&token=d90d58e8-21a5-403e-9cb9-4d065fb9c655 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fforce2025song.mp3?alt=media&token=aeed54c4-234a-4568-800a-a2b8ab0c9b11 ",
    lyrics: ["(Chorus)",
  "If you give a push or give a pull,",
  "That is force to an object.",
  "If you give a push or give a pull,",
  "That is force to an object.",
  
  "(Verse)",
  "Force is a push or a pull that will,",
  "Make an object stop.",
  "Force is a push or a pull that will,",
  "Change an object's speed.",
  "Force is a push or a pull that will,",
  "Change an object's direction.",
  "Force is a push or a pull that will,",
  "Change an object's direction.",
  
  "(Chorus)",
  "If you give a push or give a pull,",
  "That is force to an object.",
  "If you give a push or give a pull,",
  "That is force to an object.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Speed and Motion", standardNumber: "4-PS3-1", slug: "speedandmotion",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  {
    title: "Energy", standardNumber: "4-PS3-2", slug: "energy",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  {
    title: "Traveling Sound", standardNumber: "4-PS3-2", slug: "travelingsound",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ftravelingsound2025song.mp3?alt=media&token=d6cde5d6-b14d-4140-ab02-6a59ee34e86b ",
    lyrics: ["(chorus)",
  "Which one does sound travel through faster, solids, liquids, or gases?",
  "Which one does sound travel through faster, solids, liquids, or gases?",
  
  "(verse)",
  "Through solids sound travels fastest.",
  "Sound travels slowest through gases.",
  "In solids the molecules are touching,",
  "so, sound can just jump from one molecule to another.",
  "In gases molecules are so far apart,",
  "it takes time and energy for one molecule to touch another.",
  "So, sound can only jump from molecule to another when they collide.",
  "Gases take the longest time.",
  
  "(chorus)",
  "Which one does sound travel through faster, solids, liquids, or gases?",
  "Which one does sound travel through faster, solids, liquids, or gases?",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Forms of Energy", standardNumber: "4-PS3-2", slug: "formsofenergy",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fformsofenergy2025song.mp3?alt=media&token=5101cfce-2f00-468b-b7c4-89b48eec32cf ",
    lyrics: ["(chorus)",
  "Different forms of energy.",
  "Potential and kinetic,", 
  "potential and kinetic.", 
  "Different forms of energy.",
  "Potential and kinetic,", 
  "potential and kinetic.",
  
  "(verse 1)",
  "Chemical energy is stored in gas and coal.", 
  "Stored in the bonds of atoms and molecules.", 
  "Mechanical energy is stored in things",
  "that have tension, like rubber bands and springs.", 
  "Nuclear energy is stored in the nucleus of an atom,", 
  "it can be released in large amounts.",
  "Electrical energy is stored in a battery",
  "can start my car or power up my T.V.",
  
  "(chorus)",
  "Different forms of energy.",
  "Potential and kinetic,", 
  "potential and kinetic.", 
  "Different forms of energy.",
  "Potential and kinetic,", 
  "potential and kinetic.", 
  
  "(verse 2)",
  "Electromagnetic energy is radiant energy,", 
  "light, x-rays, radio waves.",
  "Motion energy is stored in movement.",
  "You get more energy the faster it's moving.", 
  "Sound energy is energy through waves,", 
  "made when a force cause something to vibrate.",
  
  "(chorus)",
  "Different forms of energy.",
  "Potential and kinetic,", 
  "potential and kinetic.", 
  "Different forms of energy.",
  "Potential and kinetic,", 
  "potential and kinetic.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "", standardNumber: "4-PS3-3", slug: "",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  {
    title: "Electric scientists", standardNumber: "4-PS3-4", slug: "electricscientists",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Felectricscientists2025video.mp4?alt=media&token=672ee26c-8c4e-464a-af95-e14edfdb8197 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Felectricscientist2025song.mp3?alt=media&token=93b064b2-dd77-4b77-9671-ae9c59a98aff ",
    lyrics: ["(chorus)",
  "Famous scientist who dealt with electricity,",
  "Famous scientist who dealt with electricity,",
  
  "(verse)",
  "Ben Franklin used his kite and key experiment,",
  "To see if lightning was a form of electric current,",
  "Ben Franklin used his kite and key experiment,",
  "To see if lightning was a form of electric current,",
  "Thomas Edison, he invented the first practical light bulb,",
  "Thomas Edison, he invented the first practical light bulb,",
  "Michael Faraday, a scientist with electricity,",
  "He made the first generator,",
  "He made the first transformer,",
  "He made the first electric motor,",
  "Discovered electromagnetic conduction,",
  
  "(chorus)",
  "scientists who dealt with electricity,",
  "Famous scientist who dealt with electricity,",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Circuits", standardNumber: "4-PS3-4", slug: "circuits",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fcircuits2025video.mp4?alt=media&token=78828d71-caa2-4e97-aac9-a5680f38cb37 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcircuits2025song.mp3?alt=media&token=8a8e26ab-6a16-4a36-9534-eb2d9133af8b ",
    lyrics: ["(chorus)",
  "A circuit is the path that electricity takes.",
  "A circuit is the path that electricity takes.",
  "A circuit is the path that electricity takes.",
  "A circuit is the path that electricity takes.",
  
  "(verse)",
  "Electricity can only flow through a closed circuit.",
  "Electricity cannot flow through an open circuit.",
  "Series circuits have only one path",
  "for electricity to flow, electricity to flow.",
  "Parallel circuits have more than one path",
  "for electricity to flow, electricity to flow.",
  
  "(chorus)",
  "A circuit is the path that electricity takes.",
  "A circuit is the path that electricity takes.",
  "A circuit is the path that electricity takes.",
  "A circuit is the path that electricity takes.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Parallel Circuits", standardNumber: "4-PS3-4", slug: "parallelcircuits",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fparallelcircuits2025song.mp3?alt=media&token=9a7d3bd6-bee5-410a-9a82-91bfa243e1c0 ",
    lyrics: ["(chorus)",
  "Parallel circuits have more than one resistor.",
  "Parallel circuits have more than one resistor.",
  "Parallel circuits have more than one resistor.",
  "Parallel circuits have more than one resistor.",
  
  "(verse)",
  "A parallel circuit is a circuit ",
  "with multiple parallel paths.",
  "Charges can flow through any of the paths ",
  "to keep the flow going.",
  "If one of the paths stop because its broken,",
  "the other paths will keep on flowing.",
  
  "(chorus)",
  "Parallel circuits have more than one resistor.",
  "Parallel circuits have more than one resistor.",
  "Parallel circuits have more than one resistor.",
  "Parallel circuits have more than one resistor.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Energy Transfer", standardNumber: "4-PS3-4", slug: "energytransfer",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fenergytransfer2025video.mp4?alt=media&token=58831dcb-2eb4-4dee-9fee-27e5162a433f ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fenergytransfer2025song.mp3?alt=media&token=831ddaef-afbe-4240-ae45-2f6e75dfab3e ",
    lyrics: ["(chorus)",
  "Let’s transform that energy, transform that energy,",
  "transform that energy, transform.",
  "Let’s transform that energy, transform that energy,",
  "transform that energy, transform.",
  
  "(verse)",
  "You can connect solar panels lots of things,",
  "and it will change light energy into electrical energy.",
  "A T.V. changes electrical energy into light energy,",
  "and a T.V. changes electrical energy into sound energy.",
  "Let’s see what kind of energy makes a car move.",
  "There’s chemical energy inside the fuel,",
  "and it turns into thermal and mechanical energy.",
  "The batteries in a flashlight have chemical energy.",
  "and when it’s turned on, what do you see? You see the light energy.",
  "Now, plain old wood has potential chemical energy.",
  "Put fire to the wood and it turns into thermal energy for cooking and heat.",
  
  "(chorus)",
  "Let’s transform that energy, transform that energy,",
  "transform that energy, transform.",
  "Let’s transform that energy, transform that energy,",
  "transform that energy, transform.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Wave Properties", standardNumber: "4-PS4-1", slug: "waveproperties",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fwaveproperties2025video.mp4?alt=media&token=2b8e0b62-2ffd-4f97-9736-18b84f63c2bc ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fwaveproperties2025song.mp3?alt=media&token=bb4409fd-4bf7-4c37-9a5d-bf10dfb2ada7 ",
    lyrics: ["(Chorus)",
  "Let’s name some properties of waves, of waves, of waves.",
  "Let’s name some properties of waves, of waves, of waves.",
  "Let’s name some properties of waves, of waves, of waves.",
  "Let’s name some properties of waves, of waves, of waves.",
  
  "(Verse)",
  "Frequency is the number of waves,",
  "That pass a point in a second.",
  
  "Wavelength, the distance between the crest,",
  "And by meters it’s measured.",
  
  "Amplitude, the height of the wave,",
  "The height of the joint.",
  
  "Period, the time it takes,",
  "For one complete wave to pass a given point.",
  
  "(Chorus)",
  "Let’s name some properties of waves, of waves, of waves.",
  "Let’s name some properties of waves, of waves, of waves.",
  "Let’s name some properties of waves, of waves, of waves.",
  "Let’s name some properties of waves, of waves, of waves.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Sound Vibration", standardNumber: "4-PS4-1", slug: "soundvibration",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsoundvibration2025video.mp4?alt=media&token=cb99546b-37d4-4f3f-a966-0ce7a9d81ce3 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsoundvibration2025song.mp3?alt=media&token=db451312-dd9d-4c4c-babe-357802dc1d67 ",
    lyrics: ["(chorus)",
  "If you did not know where sound came from, well now you know.",
  "It’s from the vibration, it’s from the vibration.",
  "If you did not know where sound came from, well now you know.",
  "It’s from the vibration, it’s from the vibration.",
  
  "(verse)",
  "When you grab your guitar and pluck on the string,",
  "Listen to the sound, it makes you want to sing.",
  "Vibration, vibration, vibration, vibration.",
  "You can speak very soft or speak very loud.",
  "Your vocal cords vibrate producing sound.",
  "Vibration, vibration, vibration, vibration.",
  
  "(chorus)",
  "If you did not know where sound came from, well now you know.",
  "It’s from the vibration, it’s from the vibration.",
  "If you did not know where sound came from, well now you know.",
  "It’s from the vibration, it’s from the vibration.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "High & Low Pitch", standardNumber: "4-PS4-1", slug: "highlowpitch",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fhighandlowpitch2025song.mp3?alt=media&token=60f9954f-b688-47fc-989a-e374c9432e13 ",
    lyrics: ["(chorus)",
  "Pitch goes high, pitch goes low,",
  "It depends on the size, now you know!",
  "Big and long make a deep, low sound,",
  "Small and short make it high all around!",
  
  "(verse)",
  "If a string is short, it’s high and bright,",
  "But a long string plays a sound so light.",
  "Big drums boom, their pitch is low,",
  "Little drums snap with a higher show!",
  
  "(chorus)",
  "Pitch goes high, pitch goes low,",
  "It depends on the size, now you know!",
  "Big and long make a deep, low sound,",
  "Small and short make it high all around!",
  
  "(verse)",
  "Air in a tube can make sounds too,",
  "Longer air columns sound deep and true.",
  "Shorter tubes make a whistling high,",
  "Pitch is the reason, here’s the why!",
  
  "(bridge)",
  "It’s all about size, it’s easy to see,",
  "Longer means low, short means key.",
  "From strings to drums, to pipes with air,",
  "Pitch is a science that’s everywhere!",
  
  "(chorus)",
  "Pitch goes high, pitch goes low,",
  "It depends on the size, now you know!",
  "Big and long make a deep, low sound,",
  "Small and short make it high all around!",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Pitch", standardNumber: "4-PS4-1", slug: "pitch",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fpitch2025song.mp3?alt=media&token=520ce9da-9964-498c-a67f-868344433638 ",
    lyrics: ["(chorus)",
  "High pitch, low pitch, sounds we hear,",
  "High pitch, low pitch, far and near!",
  "High pitch, low pitch, give it a try,",
  "Pitch is how the sound goes low or high!",
  "High pitch, low pitch, sounds we hear,",
  "High pitch, low pitch, far and near!",
  "High pitch, low pitch, give it a try,",
  "Pitch is how the sound goes low or high!",
  "(verse)",
  "A bird’s sweet chirp is high, so clear,",
  "A lion’s roar is low, you hear!",
  "The faster it vibrates, the pitch goes high,",
  "The slower it vibrates, the pitch drops by!",
  
  "(chorus)",
  "High pitch, low pitch, sounds we hear,",
  "High pitch, low pitch, far and near!",
  "High pitch, low pitch, give it a try,",
  "Pitch is how the sound goes low or high!",
  
  "(verse)",
  "A small tight string makes a high sound,",
  "A loose big drum makes a low one around!",
  "Pitch changes with size and tension too,",
  "Play with sounds to see what you can do!",
  
  "(chorus)",
  "High pitch, low pitch, sounds we hear,",
  "High pitch, low pitch, far and near!",
  "High pitch, low pitch, give it a try,",
  "Pitch is how the sound goes low or high!",
  
  "(bridge)",
  "Clap your hands or hum a tune,",
  "Explore the pitch in the afternoon!",
  "Sounds are fun, they’re everywhere,",
  "High or low, they’re in the air!",
  
  "(chorus)",
  "High pitch, low pitch, sounds we hear,",
  "High pitch, low pitch, far and near!",
  "High pitch, low pitch, give it a try,",
  "Pitch is how the sound goes low or high!",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Transverse", standardNumber: "4-PS4-1", slug: "transverse",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  {
    title: "Compression", standardNumber: "4-PS4-1", slug: "compression",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcompression2025song.mp3?alt=media&token=47ce5aec-5d0b-431a-8893-1094e3815fd5 ",
    lyrics: ["(chorus)",
  "When sound travels through matter,",
  "it’s in a compression wave, it’s in a compression wave.",
  "When sound travels through matter,",
  "it’s in a compression wave, it’s in a compression wave.",
  
  "(verse)",
  "Compression waves are longitudinal waves.",
  "Compression waves are longitudinal waves.",
  "Compression waves travel through solids, liquids, and gases.",
  "Compression waves travel through solids, liquids, and gases.",
  "Compression waves move backwards and forwards",
  "in the same direction the wave is traveling.",
  "Compression waves travels through solids.",
  "Compression waves travels through liquids.",
  "Compression waves travels through gases.",
  "Compression waves travels through gases.",
  
  "(chorus)",
  "When sound travels through matter,",
  "it’s in a compression wave, it’s in a compression wave.",
  "When sound travels through matter,",
  "it’s in a compression wave, it’s in a compression wave.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "See Through", standardNumber: "4-PS4-2", slug: "seethrough",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fseethrough2025video.mp4?alt=media&token=9fd26a05-07dc-4e05-b5b0-0f9f997444e6 ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fseethrough2025song.mp3?alt=media&token=369a78c4-6932-4cc9-b40a-df1fe1fc7a35 ",
    lyrics: ["(chorus)",
  "See through, see through, see through, see through.",
  "Can’t see, can’t see, can’t see, can’t see.",
  "See through, see through, see through, see through.",
  "Can’t see, can’t see, can’t see, can’t see.",
  
  "(verse)",
  "Transparent means that light goes right through it.",
  "Translucent means that some light can go through it.",
  "Opaque means that no light can go through it.",
  "These are some properties of materials, some properties of materials.",
  "Transparent objects are clear and through them, you can see.",
  "Translucent materials, you can’t see through as clearly.",
  "Opaque materials are opposite, you can’t see through them at all.",
  "These are some properties of materials, some properties of materials.",
  
  "(chorus)",
  "See through, see through, see through, see through.",
  "Can’t see, can’t see, can’t see, can’t see.",
  "See through, see through, see through, see through.",
  "Can’t see, can’t see, can’t see, can’t see.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Reflection", standardNumber: "4-PS4-2", slug: "reflection",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Freflection2025song.mp3?alt=media&token=15279673-9439-4862-8c6e-4e33e4bda158 ",
    lyrics: ["(chorus)",
  "Reflection happens when light bounces,",
  "off an object, off an object.",
  "Reflection happens when light bounces,",
  "off an object, off an object.",
  
  "(verse)",
  "You get more reflection from smooth surfaces",
  "just like a mirror, just like a mirror.",
  "If the surface of the object is rough,",
  "then the light scatters, then the light scatters.",
  
  "(chorus)",
  "Reflection happens when light bounces,",
  "off an object, off an object.",
  "Reflection happens when light bounces,",
  "off an object, off an object.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "My Eye", standardNumber: "4-PS4-2", slug: "myeye",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  {
    title: "Spectrum", standardNumber: "4-PS4-2", slug: "spectrum",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fspectrum2025song.mp3?alt=media&token=6bf51fc3-840a-44c9-b6f7-011bdbce70c7 ",
    lyrics: ["(chorus)",
  "The visible spectrum is made of colors,",
  "The visible spectrum is made of colors.",
  "Red, orange, yellow, green, blue, indigo, violet.",
  "Red, orange, yellow, green, blue, indigo, violet.",
  "The visible spectrum is seen as light.",
  "The visible spectrum is seen as light.",
  "Each color has a different a wavelength in the spectrum.",
  "Each color has a different a wavelength in the spectrum.",
  "Red has the longest wavelength.",
  "Red has the longest wavelength.",
  "Red has the longest wavelength.",
  "Red has the longest wavelength.",
  "Violet has the shortest wavelength.",
  "Violet has the shortest wavelength.",
  "Violet has the shortest wavelength in the spectrum,",
  "in the spectrum.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "", standardNumber: "4-PS4-3", slug: "",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  {
    title: "Organs & Functions", standardNumber: "4-LS1-1", slug: "organsfunctions",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Forgansandfunctions2025video.mp4?alt=media&token=5eb88911-5fd6-4f88-b364-09c2ca79f0ad ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Forgansandfunctions2025song.mp3?alt=media&token=67ec1093-5d73-431a-b98d-808db85c9a00 ",
    lyrics: ["(chorus)",
  "Organs and functions, yeah, yeah, yeah, yeah, yeah.",
  "Organs and functions, yeah, yeah, yeah, yeah, yeah.",
  "Organs and functions, yeah, yeah, yeah, yeah, yeah.",
  "Organs and functions, yeah, yeah, yeah, yeah, yeah.",
  
  "(verse)",
  "The liver secretes bile and excretion,",
  "form metabolism for carbs, fats & proteins.",
  "The heart is a muscle that pumps blood",
  "from your veins to the arteries and through the whole body.",
  "The kidneys are a pair and its understood,",
  "they remove waste and excess water from the blood.",
  "The lungs breathe in, breathe out again.",
  "They remove carbon dioxide and take in oxygen.",
  
  "(chorus)",
  "Organs and functions, yeah, yeah, yeah, yeah, yeah.",
  "Organs and functions, yeah, yeah, yeah, yeah, yeah.",
  "Organs and functions, yeah, yeah, yeah, yeah, yeah.",
  "Organs and functions, yeah, yeah, yeah, yeah, yeah.",
  
  "(verse)",
  "The stomach helps break down food and that’s a fact.",
  "It’s the second stop along the digestive track.",
  "Now the brain is the control room for the body.",
  "The body sends a message to the brain, now it’s got it.",
  "The brain reads the message and sends it back through",
  "to the body part telling it what to do.",
  
  "(chorus)",
  "Organs and functions, yeah, yeah, yeah, yeah, yeah.",
  "Organs and functions, yeah, yeah, yeah, yeah, yeah.",
  "Organs and functions, yeah, yeah, yeah, yeah, yeah.",
  "Organs and functions, yeah, yeah, yeah, yeah, yeah.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Skeletal System", standardNumber: "4-LS1-1", slug: "skeletalsystem",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fskeletalsystem2025video.mp4?alt=media&token=9e5369d4-a95d-45aa-8668-dd10735197ba ",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fskeletalsystem2025song.mp3?alt=media&token=2e53f879-e8b5-488a-921f-b83a0feacd79 ",
    lyrics: ["(chorus)",
  "It provides the shape for my body.",
  "My bones, my bones, my bones.",
  "It protects the organs in my body.",
  "My bones, my bones, my bones.",
  "With help from muscles, let me move my body.",
  "My bones, my bones, my bones.",
  "There’re 206 bones in my body",
  "That makes up the skeletal system.",
  
  "(verse)",
  "The bone in your head is the skull.",
  "Your collarbone is the clavicle.",
  "Your breastbone is the sternum.",
  "The humerus is where your upper arm is.",
  "Rib cage is located in your chest.",
  "Spine goes down the middle of your back.",
  "The pelvis is in your hip, close to where you sit,",
  "Where you sit.",
  "Ulnar and radius are on your forearm.",
  "The femur is your thighbone.",
  "Patella is your kneecap.",
  "Where your phalanges at? Fingers and your toes.",
  "Tibia and fibula are in your lower legs.",
  "These are my bones from my head to my toes.",
  
  "(chorus)",
  "It provides the shape for my body.",
  "My bones, my bones, my bones.",
  "It protects the organs in my body.",
  "My bones, my bones, my bones.",
  "With help from muscles, let me move my body.",
  "My bones, my bones, my bones.",
  "There’re 206 bones in my body",
  "That makes up the skeletal system.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Plant Parts", standardNumber: "4-LS1-1", slug: "plantparts",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fplantparts2025song.mp3?alt=media&token=64dfa273-9473-4f12-ae5f-d08c8e11a18c",
    lyrics: ["(chorus)",
  "Plant Parts",
  "Roots, stems, leaves, flowers, fruits, seeds",
  "Plant Parts",
  "Roots, stems, leaves, flowers, fruits, seeds",
  
  "(verse)",
  "Plant Parts",
  "The Roots take in the water and nutrients OK",
  "The Roots hold the Plant down, so it does not blow away",
  "Plant Parts",
  "The Stem takes the water and nutrients up to the Leaves",
  "The Leaves make food “Photosynthesis” yes their green",
  "The Flowers go through Fertilization they make the seeds",
  "The Fruit is the part that swells up and it holds the seeds",
  "The Seed is a tiny Plant called the Embryo",
  "and it's waiting to Germinate so that it can grow",
  
  "(chorus)",
  "Plant Parts",
  "Roots, stems, leaves, flowers, fruits, seeds",
  "Plant Parts",
  "Roots, stems, leaves, flowers, fruits, seeds",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "The Ear", standardNumber: "4-LS1-1", slug: "theear",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ftheear2025song.mp3?alt=media&token=d93c279c-aab2-4af1-873c-ffb3143fb907 ",
    lyrics: ["(Chorus)",
  "Can you hear the words coming out of my mouth?",
  "Can you hear it going down? Can you hear it going down?",
  "Can you hear the words coming out of my mouth?",
  "Can you hear it going down? Can you hear it going down?",
  
  "(Verse)",
  "The pinna, auricle sends sound to the outer ear canal.",
  "Sends sound, sends sound.",
  "The outer ear canal, a tube leading to the eardrum, it takes in the sound.",
  "In sound, in sound.",
  "Now, the eardrum, tympanic membrane, vibrates from the sound waves.",
  "Sound waves, sound waves.",
  "Then, the hammer, malleus, still passes sound to the anvil.",
  "The anvil, the anvil.",
  "Then the anvil, incus, yup, passes sound to the stirrup, the stirrup, stapes.",
  "Smallest bone in the body and it’s U-shaped.",
  "The stirrup’s open up and pass sound to the cochlea.",
  "The cochlea’s filled with fluid, the vibration causes a nerve impulse.",
  "That’s what’s up, that’s what’s up.",
  "Balance is maintained by the semicircular canals connected to the cochlea.",
  "Then the nerves carry the sound signals from the cochlea to the brain, to the brain.",
  "That’s the way you hear, that’s the way you hear, that’s the way you hear what I’m saying.",
  
  "(Chorus)",
  "Can you hear the words coming out of my mouth?",
  "Can you hear it going down? Can you hear it going down?",
  "Can you hear the words coming out of my mouth?",
  "Can you hear it going down? Can you hear it going down?",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Circulatory System", standardNumber: "4-LS1-1", slug: "circulatorysystem",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  {
    title: "Digestive System", standardNumber: "4-LS1-1", slug: "digestivesystem",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fdigestivesystem2025song.mp3?alt=media&token=ffadc11c-40b9-4c09-a1de-571b10f18dfc",
    lyrics: ["(chorus)",
  "Come take a ride, come take a ride with me.",
  "Come take a ride through the digestive system.",
  "Come take a ride, come take a ride with me.",
  "Come take a ride through the digestive system.",
  
  "(verse 1)",
  "We enter through the mouth, through the mouth, yeah.",
  "Digestive process begins in the mouth, yeah.",
  "With salivary enzymes and the process of chewing,",
  "we are partly broken down, we are partly broken down.",
  "All aboard we are going through the esophagus into the stomach,",
  "where we take a bath in gastric acid,",
  "mixed with chyme those are stomach acids.",
  
  "(chorus)",
  "Come take a ride, come take a ride with me.",
  "Come take a ride through the digestive system.",
  "Come take a ride, come take a ride with me.",
  "Come take a ride through the digestive system.",
  
  "(verse 2)",
  "Next stop is the small intestines.",
  "We are broken down more in the small intestines.",
  "Sing along, the first part the duodenum,",
  "(d-u-o-d-e-n-u-m), (d-u-o-d-e-n-u-m).",
  "Then we enter the jejunum.",
  "(j-e-j-u-n-u-m), (j-e-j-u-n-u-m),",
  "and the ileum, (i-l-e-u-m), (i-l-e-u-m).",
  "Next stop is the large intestines.",
  "Here we go, entering the cecum,",
  "(c-e-c-u-m), (c-e-c-u-m).",
  "Solid waste is stored in the rectum, true.",
  "Until we do a number two, eww!",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  {
    title: "Nervous System", standardNumber: "4-LS1-1", slug: "nervoussystem",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  {
    title: "Muscular System", standardNumber: "4-LS1-1", slug: "muscularsystem",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  
  {
    title: "Respiratory System", standardNumber: "4-LS1-1", slug: "respiratorysystem",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Frespiratorysystem2025song.mp3?alt=media&token=65825bea-6c19-466f-88d8-880a61c1fc35",
    lyrics: ["(Intro)",
  "Breathe in, breathe out with your respiratory system.",
  "Breathe in, breathe out with your respiratory system.",
  
  "(Chorus)",
  "(Breathe in—breathe in) Get oxygen.",
  "(Breathe in—breathe in) Rib muscles contract.",
  "(Breathe in—breathe in) Pull ribs up and out.",
  "(Breathe in—breathe in) The diaphragm muscle contracts.",
  "(Breathe out—breathe out) Get rid of gases.",
  "(Breathe out—breathe out) Your body doesn’t need.",
  "(Breathe out—breathe out) Rib muscles relax.",
  "(Breathe out—breathe out) The diaphragm muscle relaxes.",
  
  "(Verse 1)",
  "Now oxygen enters through the mouth and the nose,",
  "Then passes through the larynx and trachea.",
  "The trachea is a tube that enters the chest cavity.",
  "Breathe in—breathe out.",
  "In the chest cavity, the trachea splits in two,",
  "Smaller tubes called the bronchi.",
  "Each bronchus then divides, forming the bronchial tube.",
  "Oxygen goes straight to the lungs (to the lungs).",
  
  "(Chorus)",
  "(Breathe in—breathe in) Get oxygen.",
  "(Breathe in—breathe in) Rib muscles contract.",
  "(Breathe in—breathe in) Pull ribs up and out.",
  "(Breathe in—breathe in) The diaphragm muscle contracts.",
  "(Breathe out—breathe out) Get rid of gases.",
  "(Breathe out—breathe out) Your body doesn’t need.",
  "(Breathe out—breathe out) Rib muscles relax.",
  "(Breathe out—breathe out) The diaphragm muscle relaxes.",
  
  "(Verse 2)",
  "The little sacs in the lungs are called alveoli.",
  "The alveoli are surrounded by capillaries.",
  "The capillaries diffuse the oxygen from the alveoli—alveoli (yeah).",
  "At the same time, the veins release the carbon dioxide into the alveoli—into the alveoli.",
  "When you breathe out, the carbon dioxide is leaving the lungs.",
  "It's leaving the lungs.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  
  {
    title: "The Skin", standardNumber: "4-LS1-1", slug: "theskin",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  
  {
    title: "Body Systems", standardNumber: "4-LS1-2", slug: "bodysystems",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fbodysystems2025video.mp4?alt=media&token=b9938e87-826f-4d48-8e9e-3ba75b76f3cd",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fbodysystems2025song.mp3?alt=media&token=52796d6d-dc79-4bd2-ada2-cce44399427e",
    lyrics: ["(chorus)",
  "Rock your body, rock your body systems.",
  "Move your body, move your body systems.",
  "Rock your body, rock your body systems.",
  "Move your body, move your body systems.",
  
  "(verse1)",
  "Immune system defends our body.",
  "Skeletal system are your bones.",
  "Excretory system cleans our body of poisons.",
  "Muscular system are your muscles.",
  "Endocrine system is in control of your thyroid gland.",
  "Yeah, yeah, yeah.",
  
  "(chorus)",
  "Rock your body, rock your body systems.",
  "Move your body, move your body systems.",
  "Rock your body, rock your body systems.",
  "Move your body, move your body systems.",
  
  "(verse2)",
  "Digestive system is your mouth and stomach.",
  "Respiratory system delivers your oxygen.",
  "Nervous system is your control center.",
  "Nervous system is your control center.",
  "Circulatory system is your life pump",
  "That keeps the blood flowing,",
  "That keeps the blood flowing.",
  "Circulatory system is your life pump",
  "That keeps the blood flowing,",
  "That keeps the blood flowing.",
  
  "(chorus)",
  "Rock your body, rock your body systems.",
  "Move your body, move your body systems.",
  "Rock your body, rock your body systems.",
  "Move your body, move your body systems.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  
  {
    title: "Nervous System", standardNumber: "4-LS1-2", slug: "nervoussystem",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  
  {
    title: "Fossils", standardNumber: "4-ESS1-1", slug: "fossils",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  
  {
    title: "My Three Rocks", standardNumber: "4-ESS1-1", slug: "mythreerocks",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmythreerocks2025video.mp4?alt=media&token=0138a21e-1381-437b-b9d1-87552c3cb5cb",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmythreerocks2025song.mp3?alt=media&token=38261703-9b39-477d-977e-e13ce5c01b5a",
    lyrics: ["(chorus)",
  "My three rocks.",
  "Sedimentary, igneous, and metamorphic.",
  
  "(verse)",
  "Sedimentary rocks are formed in layers, formed in layers.",
  "Sedimentary rocks are found near water,",
  "Some have fossils and found near water.",
  
  "Igneous rocks were here since the beginning.",
  "Igneous rocks hot, lava cooled and hardened.",
  
  "When you transform sedimentary and igneous rocks",
  "With pressure, they make metamorphic rocks.",
  "When you transform sedimentary and igneous rocks",
  "With heat, they make metamorphic rocks.",
  
  "(chorus)",
  "My three rocks.",
  "Sedimentary, igneous, and metamorphic.",
  "My three rocks.",
  "Sedimentary, igneous, and metamorphic.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  
  {
    title: "Rock Cycle", standardNumber: "4-ESS1-1", slug: "rockcycle",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Frockcycle2025song.mp3?alt=media&token=dda5788a-2016-4539-a191-f63a2f9c9b75",
    lyrics: ["(chorus)",
  "The rock cycle can't stop and don’t stop.",
  "The rock cycle can't stop and don’t stop.",
  
  "(verse)",
  "All rocks on this earth are made up of the same stuff,",
  "even though all rocks are not the same, not the same.",
  "You have igneous rocks, and they can change",
  "into sedimentary rocks, and they can change",
  "into metamorphic rocks, and they can change",
  "into igneous rock.",
  "Rock cycle",
  
  "(chorus)",
  "The rock cycle can't stop and don’t stop.",
  "The rock cycle can't stop and don’t stop.",
  
  "(verse)",
  "When magma cools and make crystals, it forms igneous rocks.",
  "Those rocks break apart into sediments, making sedimentary rock.",
  "When that rock is heated it changes its form.",
  "Metamorphosis is what it’s called.",
  "Metamorphic rock can break down too, into sediments, making sedimentary rock.",
  
  "(chorus)",
  "The rock cycle can't stop and don’t stop.",
  "The rock cycle can't stop and don’t stop.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  
  {
    title: "Weathering", standardNumber: "4-ESS2-1", slug: "weathering",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fweathering2025video.mp4?alt=media&token=a9649c8d-b5b6-4180-b9f9-4b1746923164",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fweathering2025song.mp3?alt=media&token=d7242a48-cd46-42b9-8136-1dbab7e492c4",
    lyrics: ["(Chorus)",
  "Breaking down Earth’s surface.",
  "Breaking down Earth’s surface.",
  "By weathering,",
  "By erosion.",
  "Breaking down Earth’s surface.",
  "Breaking down Earth’s surface.",
  "By weathering,",
  "By erosion.",
  
  "(Verse)",
  "Weathering is when the rain and wind,",
  "Wears away the Earth’s surface.",
  
  "Erosion is when rocks and soil are broken down,",
  "And wears down the Earth’s surface.",
  
  "Deposition is when those broken-down rocks and minerals,",
  "Are transported to another place.",
  
  "(Chorus)",
  "Breaking down Earth’s surface.",
  "Breaking down Earth’s surface.",
  "By weathering,",
  "By erosion.",
  "Breaking down Earth’s surface.",
  "Breaking down Earth’s surface.",
  "By weathering,",
  "By erosion.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  
  {
    title: "Surface Change", standardNumber: "4-ESS2-1", slug: "surfacechange",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsurfacechange2025video.mp4?alt=media&token=ac73c746-d5ee-470f-9d84-f04f7a4c0eb8",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsurfacechange2025song.mp3?alt=media&token=6649da82-6912-4a1a-8016-9a869576e845",
    lyrics: ["(chorus)",
  "Now I see a change, you see a change, I see a change, on the surface.",
  "They see a change, we see a change, they see a change, on the surface.",
  
  "(verse1)",
  "Now, what can affect the changes of the earth’s surface?",
  "Let’s see, that’s erosion, erosion.",
  "When rocks and soil are broken down and wear down the surface,",
  "That’s erosion, erosion.",
  "Weathering happens when rocks break apart",
  "Due to the weather, mechanical and chemical.",
  "Weathering happens when rocks break apart",
  "Due to the weather, mechanical and chemical.",
  "Mechanical weathering happens when rocks break apart",
  "Because of flowing water or ice.",
  "Mechanical weathering happens when rocks break apart",
  "Because it’s too cold or too hot.",
  "In chemical weathering, water dissolves the minerals",
  "In the rock and the rock breaks apart.",
  "In chemical weathering, water dissolves the minerals",
  "In the rock and the rock breaks apart.",
  
  "(chorus)",
  "Now I see a change, you see a change, I see a change, on the surface.",
  "They see a change, we see a change, they see a change, on the surface.",
  "Now I see a change, you see a change, I see a change, on the surface.",
  "They see a change, we see a change, they see a change, on the surface.",
  
  "(verse2)",
  "A canyon is a valley between cliffs.",
  "There’s often a river flowing through it.",
  "The river eroded the layers of rocks",
  "And weather caused erosion to occur.",
  "Mountains sit high, they’re naturally made",
  "When the earth’s crust folds into great waves.",
  "From lava, a volcanic mountain is made",
  "And erosion gives mountains their shape.",
  "It can be an earthquake that changes the shape",
  "Of the earth’s surface that starts to shake.",
  "It can be a volcano that’s opened up",
  "From which lava, gases, and rock erupt.",
  
  "(chorus)",
  "Now I see a change, you see a change, I see a change, on the surface.",
  "They see a change, we see a change, they see a change, on the surface.",
  "Now I see a change, you see a change, I see a change, on the surface.",
  "They see a change, we see a change, they see a change, on the surface.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  
  {
    title: "Water Cycle", standardNumber: "4-ESS2-1", slug: "watercycle",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fwatercycle2025video.mp4?alt=media&token=21f248f9-e435-4a27-b6a7-b457000cb013",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fwatercycle2025song.mp3?alt=media&token=5a551a0a-9e64-4c2d-9eb9-24ee6d6c3ca2",
    lyrics: ["(Chorus)",
  "It’s a circle, a circle, yup, a circle.",
  "The water cycle goes in a circle.",
  "Starts with evaporation.",
  "Rise to precipitation.",
  "Drops back down in the form of snow, sleet, or rain.",
  
  "(Verse)",
  "Water is one of the reasons why there’s life on Earth.",
  "Water covers 75 percent of the Earth.",
  "The equator is an imaginary line,",
  "That divides the Earth into two sides.",
  "Halfway between the North and South Pole, yeah,",
  "The Northern Hemisphere, the Southern Hemisphere.",
  
  "Now the water on Earth goes in a cycle.",
  "What a coincidence, it’s called the water cycle.",
  "Heat from the sun causes water from the lakes,",
  "Oceans and rivers to evaporate.",
  "That evaporated water rises till it cools,",
  "Then condenses into droplets or ice crystals.",
  "Forming a cloud, the cloud lets the water back out,",
  "To the ground, rivers, and ponds.",
  "In the oceans and into the lakes,",
  "And starts all over when the water evaporates.",
  
  "(Chorus)",
  "It’s a circle, a circle, yup, a circle.",
  "The water cycle goes in a circle.",
  "Starts with evaporation.",
  "Rise to precipitation.",
  "Drops back down in the form of snow, sleet, or rain.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  
  {
    title: "Plates", standardNumber: "4-ESS2-2", slug: "plates",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  
  {
    title: "Natural Resources", standardNumber: "4-ESS3-1", slug: "naturalresources",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fnaturalresources2025video.mp4?alt=media&token=41ca1ac8-d85f-4732-a6e8-31c0c0f5024f",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fnaturalresources2025song.mp3?alt=media&token=970befde-e5f3-490c-b6b6-695a05fbb105",
    lyrics: ["(Chorus)",
  "Natural resources are resources,",
  "found in nature and used by people.",
  "Natural resources are resources,",
  "found in nature and used by people.",
  
  "(Verse 1)",
  "Renewable resources are trees, fish, and horses.",
  "All plants and animals, well,",
  "they reproduce and replace themselves.",
  "Renewable resources are trees, fish, and horses.",
  "All plants and animals, well,",
  "they reproduce and replace themselves.",
  
  "Nonrenewable resources are oil, gas, and coal.",
  "They take millions of years to form,",
  "so, once they’re used up, they’re gone.",
  "Nonrenewable resources are oil, gas, and coal.",
  "They take millions of years to form,",
  "so, once they’re used up, they’re gone.",
  
  "(Chorus)",
  "Natural resources are resources,",
  "found in nature and used by people.",
  "Natural resources are resources,",
  "found in nature and used by people.",
  
  "(Verse 2)",
  "An inexhaustible resource is sunlight.",
  "It will always be around during our lifetime.",
  "An inexhaustible resource is sunlight.",
  "It will always be around during our lifetime.",
  
  "Recyclable resources can be used more than once.",
  "Some of these resources are copper, tin, and aluminum.",
  "Recyclable resources can be used more than once.",
  "Some of these resources are copper, tin, and aluminum.",
  
  "(Chorus)",
  "Natural resources are resources,",
  "found in nature and used by people.",
  "Natural resources are resources,",
  "found in nature and used by people.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  
  {
    title: "Fossil Fuels", standardNumber: "4-ESS3-1", slug: "fossilfuels",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  
  {
    title: "Pollution", standardNumber: "4-ESS3-1", slug: "pollution",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: "",
    music: "",
    lyrics: [],
  },
  
  {
    title: "Reduce, Reuse, & Recycle", standardNumber: "4-ESS3-2", slug: "reducereuserecycle",
    gameType: "multipleChoice", titleImage: "",
    description: "",
    video: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Freducereuseandrecycle2025video.mp4?alt=media&token=e70c95fb-a41d-41b7-b8c3-ef00cb03b098",
    music: " https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Freducereuserecycle2025song.mp3?alt=media&token=55526bc5-628f-4a12-94b4-b0b6ea6dda21",
    lyrics: ["(Chorus)",
  "Reducing, reusing, and recycling protects your environment.",
  "Reducing, reusing, and recycling protects your environment.",
  "Reducing, reusing, and recycling can eliminate waste.",
  
  "(Verse)",
  "You can reduce by refusing store bags.",
  "Carry small items out in your hands.",
  "You can reuse cups that’s washable,",
  "Instead of foam cups that’s disposable.",
  "You can recycle papers and plastics, papers, and plastics,",
  "Yup, yup, yup, papers and plastics.",
  
  "(Chorus)",
  "Reducing, reusing, and recycling protects your environment.",
  "Reducing, reusing, and recycling protects your environment.",
  "Reducing, reusing, and recycling can eliminate waste.",
  
  "© Smart Board Learning, LLC. All rights reserved.",],
  },
  

];
export default topics;
